"use client";

import { VercelToolbar as DefaultVercelToolbar } from "@vercel/toolbar/next";

export function VercelToolbar() {
  // TODO: Replace with actual auth - only internal employees can see this
  const isEmployee = false;
  return isEmployee ? <DefaultVercelToolbar /> : null;
}
